<template>
  <div class="min-h-screen w-full bg-[#0A1633] flex flex-col items-center justify-center px-4 py-10">

    <!-- Marca Sinergy Group: el logo es blanco, va sobre el fondo oscuro -->
    <div class="flex flex-col items-center mb-8">
      <img
        src="@/components/imgs/logo-sinergy-blanco.png"
        alt="Sinergy Group"
        class="h-16 sm:h-20 w-auto"
      />
      <p class="mt-3 text-xs sm:text-sm tracking-wide text-gray-300 text-center">
        Ingeniería en Transmisión de Datos
      </p>
    </div>

    <!-- Tarjeta de acceso -->
    <div class="w-full max-w-sm bg-white rounded-xl shadow-2xl px-6 py-8 sm:px-8">

      <div class="text-center mb-6">
        <h1 class="text-2xl font-bold text-[#0A1633] tracking-wide">SAFCO</h1>
        <p class="text-sm text-gray-500 mt-1">Control de combustible</p>
      </div>

      <!-- Usuario -->
      <label class="block text-sm font-medium text-gray-700 mb-1" for="campo-usuario">
        Usuario
      </label>
      <input
        id="campo-usuario"
        ref="campoUsuario"
        v-model="username"
        type="text"
        autocomplete="username"
        autocapitalize="none"
        autocorrect="off"
        spellcheck="false"
        :disabled="cargando"
        class="w-full mb-4 px-3 py-2 border border-gray-300 rounded-lg text-gray-800
               focus:outline-none focus:ring-2 focus:ring-[#FF6600] focus:border-[#FF6600]
               disabled:bg-gray-100"
        @keyup.enter="iniciarSesion"
      />

      <!-- Contraseña -->
      <label class="block text-sm font-medium text-gray-700 mb-1" for="campo-clave">
        Contraseña
      </label>
      <div class="relative mb-4">
        <input
          id="campo-clave"
          v-model="password"
          :type="mostrarClave ? 'text' : 'password'"
          autocomplete="current-password"
          :disabled="cargando"
          class="w-full px-3 py-2 pr-20 border border-gray-300 rounded-lg text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-[#FF6600] focus:border-[#FF6600]
                 disabled:bg-gray-100"
          @keyup.enter="iniciarSesion"
        />
        <button
          type="button"
          class="absolute inset-y-0 right-0 px-3 text-xs font-medium text-[#FF6600] hover:underline"
          :aria-label="mostrarClave ? 'Ocultar contraseña' : 'Mostrar contraseña'"
          @click="mostrarClave = !mostrarClave"
        >
          {{ mostrarClave ? 'Ocultar' : 'Mostrar' }}
        </button>
      </div>

      <!-- Mensaje de error -->
      <p
        v-if="error"
        class="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2"
        role="alert"
      >
        {{ error }}
      </p>

      <!-- Botón -->
      <button
        type="button"
        :disabled="cargando"
        class="w-full py-2.5 rounded-lg bg-[#FF6600] text-white font-semibold
               hover:bg-[#e65c00] transition-colors
               focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#FF6600]
               disabled:opacity-60 disabled:cursor-not-allowed"
        @click="iniciarSesion"
      >
        {{ cargando ? 'Ingresando…' : 'Ingresar' }}
      </button>
    </div>

    <p class="mt-8 text-xs text-gray-400 text-center">
      Sinergy Group · Acceso restringido
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import { authStore } from "@/stores/authStore.js";

const BACKEND_URL =
  process.env.VUE_APP_BACKEND_URL || "http://localhost:8081";

const route = useRoute();
const router = useRouter();

const username = ref("");
const password = ref("");
const mostrarClave = ref(false);
const cargando = ref(false);
const error = ref("");
const campoUsuario = ref(null);

onMounted(() => {
  campoUsuario.value?.focus();
});

async function iniciarSesion() {
  if (cargando.value) return;

  error.value = "";

  if (!username.value.trim() || !password.value) {
    error.value = "Escribe tu usuario y tu contraseña.";
    return;
  }

  cargando.value = true;

  try {
    const r = await axios.post(`${BACKEND_URL}/auth/login`, {
      username: username.value.trim(),
      password: password.value,
    });

    authStore.definirUsuario(r.data?.usuario || null);
    password.value = "";

    const destino = route.query.redirect || "/";
    router.replace(destino);
  } catch (e) {
    authStore.limpiar();
    error.value =
      e?.response?.data?.error ||
      "No se pudo conectar con el servidor. Inténtalo de nuevo.";
  } finally {
    cargando.value = false;
  }
}
</script>
